import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { buildReport, getReportParams } from "@mnjsplatform/data/lib/actions/reportActions";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ReportBuildViewer from "@mnjsplatform/components/lib/common/Reports/ReportBuildViewer";
import Alert from "@mnjsplatform/components/lib/common/Alert";
import ReportPlaceholder from "@mnjsplatform/components/lib/common/Reports/ReportPlaceholder";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";

class TestReport extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      rep1:true,
      rep2:false
    }
  }

  componentDidMount() {
  }

  h1 = () => {
    this.setState({rep1:!this.state.rep1});
  };

  h2 = () => {
    this.setState({rep2:!this.state.rep2});
  };

  render() {
    return (<div>
      <button onClick={this.h1}>Show/Hide 1</button>
      <button onClick={this.h2}>Show/Hide 2</button>

      {this.state.rep1 &&
      <ReportPlaceholder reportKey="KP_ListProfileE" reportId="KP_ListProfileE" params={{"BeginDate":"2019-12-16T00:00:00"}}>
        {(reportParamsItem, build) =><>
          <div className="col-md-5">
            <strong>Report1</strong>
            <ComplexParam dataItem={reportParamsItem} showApplyButton={false} renderParams={this.paramRender} />
            <button onClick={build}>Build Report</button>
          </div>
        </>}
      </ReportPlaceholder>}
      <Alert />
    </div>);
  }

  paramRender = (h) => {

    return (<div className="row">
      <div className="col-md-12">
        {h.fs.map((fi) => {

          const fn = fi.Name;

          return (<React.Fragment key={fn}>

            <div className="row">
              <div className="col-md-3 field-title">
                {h.lbl(fn)}
              </div>
              <div className="col-md-9">
                {h.ed(fn)}
              </div>
            </div>
            <hr/>
          </React.Fragment>)
        })}

      </div>
    </div>)
  };
}

TestReport.propTypes = {
  dispatch: PropTypes.func.isRequired
};


TestReport.defaultProps = {};

function mapStateToProps(state, ownProps) {

  let reportKey = "defaultReport";

  if (ownProps.reportKey)
    reportKey = ownProps.reportKey;

  const repParamPath = state.reportBuildState[reportKey].paramPath;

  if (!repParamPath)
    return {};

  const reportItem = state.dynState[repParamPath];

  return {
    reportParamsItem: reportItem
  };
}

export default connect(mapStateToProps)(TestReport);